import CONSTANTS from '@/constants'
import appVersion from '../../../helpers/appVersion'

interface AppState {
  isAppLoading: boolean
  isPageLoading: boolean
  isComponentLoading: boolean
  appErrors: Array<string>
  appNotifications: Array<string>
  appSuccesses: Array<string>
  appVersion?: string
  noHeaderRoutes: Array<string>
  plansLink: string
  unbounceScript: string
}

const state: AppState = {
  isAppLoading: true,
  isPageLoading: true,
  isComponentLoading: true,
  appErrors: [],
  appNotifications: [],
  appSuccesses: [],
  appVersion,
  noHeaderRoutes: CONSTANTS.ROUTING_RULES.NAVBAR_HIDDEN,
  plansLink: CONSTANTS.PLANS.LANDING_PAGE_LINK,
  unbounceScript: CONSTANTS.UNBOUNCE_SCRIPT,
}

export { AppState, state }
